import React, { useEffect, useState } from "react";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  tokenUsuario,
  urlListarModelosMensagem,
} from "../../../utils/constants";
import CustomPagination from "../../../components/PaginationTable";

export const TableDados = ({ nome }) => {
  const [contatos, setContatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams2 = new URLSearchParams(location.search);

  const listarContatos = async () => {
    try {
      const response = await axios.post(
        `${urlListarModelosMensagem}?pagina=${pagina}`,
        {
          token: tokenUsuario,
          nome: nome,
        }
      );
      return response.data.data;
    } catch (error) {
      return null;
    }
  };

  const handlePageChange = (newPage) => {
    setPagina(newPage);
    setLoading(true);
    listarContatos(newPage);
  };

  const alterarContato = (event) => {
    navigate({
      pathname: "/modelos/alterar",
      search: createSearchParams({
        name: event.row.name,
      }).toString(),
    });
  };

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      const lista = await listarContatos(pagina);
      searchParams2.set("pagina", pagina);
      const novaURL = `${location.pathname}?${searchParams2.toString()}`;
      navigate(novaURL);
      setContatos(lista);
      setLoading(false);
    };
    run();
  }, [pagina]);

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      const lista = await listarContatos();
      setContatos(lista);
      setLoading(false);
    };
    run();
  }, [nome]);

  const columns = [
    { field: "name", headerName: "Nome", width: 355 },
    {
      field: "category",
      headerName: "Categoria",
      width: 355,
      renderCell: (params) => {
        switch (params.value) {
          case "MARKETING":
            return "Marketing";
          case "UTILITY":
            return "Utilidade";
          default:
            return "Autenticação";
        }
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 355,
      renderCell: (params) => {
        switch (params.value) {
          case "PENDING":
            return "Pendente";
          case "APPROVED":
            return "Aprovado";
          default:
            return "Rejeitado";
        }
      },
    },
  ];

  return (
    <>
      <div style={{ width: "100%" }}>
        {loading ? (
          <CircularProgress
            style={{ height: "20px", width: "20px" }}
            color="primary"
          />
        ) : (
          <DataGrid
            rows={contatos}
            columns={columns}
            loading={loading}
            disableSelectionOnClick
            disableColumnMenu
            disableColumnSelector
            disableRowSelectionOnClick
            rowHeight={40}
            headerHeight={40}
            autoHeight={true}
            onRowClick={alterarContato}
            components={{
              Pagination: (props) => (
                <CustomPagination {...props} onPageChange={handlePageChange} />
              ),
            }}
          />
        )}
      </div>
    </>
  );
};
